export default "__VITE_ASSET__CtnRRUOd__"